// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"668":"0c6157c8","867":"2d4b7208"}[chunkId] + ".chunk.js";
};